import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { Dialog } from './../../container/dialog';

@Component({
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss'],
  standalone: false,
})
export class InputDialogComponent extends Dialog implements OnInit {
  @Input() data: string = '';

  constructor(private dialogRef: MatDialogRef<InputDialogComponent>) {
    super();
  }

  ngOnInit(): void {}

  public save() {
    this.dialogRef.close(this.data);
  }

  public close() {
    this.dialogRef.close();
  }
}
